import { useState,useEffect } from "react";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import { getFirestore, setDoc,doc, getDoc } from "firebase/firestore";
import {FaWindowClose} from "react-icons/fa";

export default function AddVideoPromoCode(props){

    var celebId=props.id;
    const db=getFirestore();
    const [promoTitle,setPromoTitle]=useState("");
    const [promoCode,setPromoCode]=useState("");
    const [discount,setDiscount]=useState("");
    const [totalCodes,setTotalCodes]=useState("");
    const [expiryDate,setExpiryDate]=useState(dayjs().toDate());

    useEffect(()=>{},[  ])


    return (
        <div className="h-[600px] w-3/4 bg-white/80 backdrop-blur-sm absolute flex flex-col gap-2 justify-center items-start p-10">
            <button 
            onClick={()=>{props.onClose()}}
            className="w-full flex justify-end items-center h-12">
                <FaWindowClose color="black" size={50}/>
            </button>
            <div className="text-black font-bold flex justify-center items-center w-full mb-8 text-3xl">Add New Video Request Promo</div>
            <div className="flex flex-row w-full justify-between gap-5 items-center text-black">
                <div className="text-black font-bold text-2xl ">Promo Title</div>
                <input
                key={"promoTitle"}
                value={promoTitle}
                onChange={(e)=>{setPromoTitle(e.target.value);}}
                placeholder="Promo Title" className="p-2 bg-black text-white"></input>
            </div>
            <div className="flex flex-row w-full justify-between gap-5 items-center text-black">
                <div className="text-black font-bold text-2xl ">Promo Code</div>
                <input
                key={"promoCode"}
                value={promoCode}
                onChange={(e)=>{ setPromoCode(e.target.value)}}
                placeholder="Promo Code" className="p-2 bg-black text-white"></input>
            </div>
            <div className="flex flex-row w-full justify-between gap-5 items-center text-black">
                <div className="text-black font-bold text-2xl ">Promo Discount</div>
                <input 
                type="number"
                value={discount}
                onChange={(e)=>{setDiscount(e.target.value)}}
                placeholder="Promo Discount" className="p-2 bg-black text-white"></input>
            </div>
            <div className="flex flex-row w-full justify-between gap-5 items-center text-black">
                <div className="text-black font-bold text-2xl ">Total Promo Codes</div>
                <input
                type="number"
                value={totalCodes}
                onChange={(e)=>{setTotalCodes(e.target.value)}}
                placeholder="Total Promo Codes" className="p-2 bg-black text-white"></input>
            </div>
            <div className="flex flex-row w-full justify-between gap-5 items-center text-black">
                <div className="w-2/4 text-black font-bold text-2xl ">Expiry Date</div>
                <div>
                <DatePicker
                    className="w-full p-2 rounded-sm bg-black/80 text-white"
                    selected={expiryDate}
                    onSelect={(date) => setExpiryDate(date)} //when day is clicked
                />
                </div>
            </div>

            <div className="font-bold text-black w-full mt-5 flex justify-center items-center">
                <button
                onClick={async()=>{

                    var currentDoc= await getDoc(doc(db,"celebrities",props.id));
                    var data=currentDoc.data();

                    data["videoRequest"]["promos"].push(
                        {
                            "promoCode":promoCode,
                            "promoDiscount":discount,
                            "promoTitle":promoTitle,
                            "totalPromoCodes":totalCodes,
                            "expiry":expiryDate
                        }
                    );

                    setDoc(doc(db,"celebrities",props.id),data,{merge:true});

                    props.onClose();
                    
                }}
                className="font-bold text-white hover:scale-105 rounded-3xl bg-red-500 p-3 w-48 h-12 flex justify-center items-center">Add</button>
            </div>


        </div>
    )


};
